// generated from 7_706 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const firstSessionSinceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("first_session_since_filter"),
  comparison_key: z.enum([
    "6", // 3_028 (39.29%)
    "4", // 2_871 (37.26%)
    "3", // 1_304 (16.92%)
    "5", // 503 (6.53%)
  ]),
  display_name: z.string(),
  // undefined: 3_005 (39.00%), defined 4_701 (61.00%)
  raw_value: z
    .union([
      // number samples: 3_613 (76.86%)
      // integer: 3_496 (96.76%)
      // avg: 39.25, min: 0, max: 5476
      z.number().min(0),
      // string samples: 1_088 (23.14%)
      // format date: 1_086 (99.82%)
      z.string(),
    ])
    .optional(),
  value: z.union([
    // number samples: 5_899 (76.55%)
    // integer: 5_746 (97.41%)
    // avg: 29.28, min: 0, max: 5476
    z.number().min(0),
    // string samples: 1_807 (23.45%)
    // format date: 1_805 (99.89%)
    z.string(),
  ]),
  varies_by_app_group: z.literal(false),
});
